import { FC, useState } from 'react';
import { useRouter } from 'next/router';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import Link from 'next/link';
import styles from './Header.module.scss';
import { MENU_LINKS } from '@/helpers/variables';

const Header: FC = () => {
  const NEW_MENU_ITEM_NAME = 'Списки';

  const [isMobileMenu, setIsMobileMenu] = useState(false);

  const router = useRouter();
  const [inputSearch, setInputSearch] = useState('');

  const setMenuModeHandle = () => {
    setIsMobileMenu(!isMobileMenu);
  };

  const getSearchWord = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputSearch(event.target.value);
  };

  const searchByPressEnter = (event: React.KeyboardEvent<object>) => {
    if (String(event.code) == 'Enter') {
      router.push(`/search/${searchWord}`);
    }
  };

  const isMainPage = useGetUrlPath().length === 1;

  const searchWord = inputSearch.includes(' ') ? inputSearch.split(' ').join('+') : inputSearch;

  return (
    <div className={styles.header} menu-data={isMobileMenu ? 'mobile-menu' : 'desktop-menu'}>
      <Link prefetch={false} href="/" className={styles.logo}>
        {isMainPage ? <h1 className={styles.logo__title}>Электронная библиотека bookz.ru</h1> : <span className={styles.logo__title}>Электронная библиотека bookz.ru</span>}
        <span className={styles.logo__subTitle}> скачивайте книги тут</span>
      </Link>
      <div className={styles.menu}>
        <div className={styles.menu__btn} onClick={setMenuModeHandle}>
          <div className={styles.burger}>
            <span className={styles.burger__topper}></span>
            <span className={styles.burger__bottom}></span>
            <span className={styles.burger__footer}></span>
          </div>
          <div className={styles.menu__txt}>Меню</div>
        </div>

        <ul className={`${styles.menuList} ${styles.menuList_mobToggle}`}>
          {MENU_LINKS.map((item) => (
            <li key={item.link} className={item.name === NEW_MENU_ITEM_NAME ? `${styles.menuList__item} ${styles.menuList__item_new}` : `${styles.menuList__item}`}>
              <Link prefetch={false} className={styles.menuList__itemLink} href={item.link}>
                {item.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className={styles.search}>
        <input onChange={getSearchWord} onKeyDown={searchByPressEnter} className={styles.search__input} type="text" placeholder="Поиск..." />
        {!!inputSearch.length ? (
          <Link prefetch={false} className={styles.search__button} href={`/search/${searchWord}`}>
            Найти
          </Link>
        ) : (
          <div className={styles.search__button}>Найти</div>
        )}
      </div>
    </div>
  );
};

export default Header;
